/**
 * Role-based UI permission helpers
 * Backend enforces authorization independently; these only control UI visibility
 */

export const canEdit = (role) => role === 'Owner' || role === 'Admin';
export const canDelete = (role) => role === 'Owner';
export const canManageMembers = (role) => role === 'Owner' || role === 'Admin';

/**
 * The signed-in user's role in an organisation. The API returns none, so the creator (whom the API
 * makes the organisation's admin) is the Owner and anyone else gets no edit controls here.
 */
export const roleFor = (org, selfUserId) => {
  if (org?.userRole || org?.role) return org.userRole || org.role;
  if (selfUserId != null && org?.creatorId > 0 && Number(org.creatorId) === Number(selfUserId)) return 'Owner';
  return null;
};
